export const gettreeStruct = (data) => {
  const layers = data.reduce(
    (acc, el) => (el.position.length > acc ? el.position.length : acc),
    0
  );

  const findMax = (list) =>
    list.reduce(
      (acc, el) => (el.position.length > acc ? el.position.length : acc),
      0
    );

  const layersAggregated = new Array(findMax(data))
    .fill(1)
    .map((_, depth) => data.filter((e) => e.position.length === depth + 1));

  const layersSeparated = layersAggregated.map((layer, depth) => {
    let indexes = [
      ...new Set(layer.map((p) => p.position.slice(depth - 1, depth))),
    ];

    const groups = indexes.map((relativePosition) => {
      return layer.filter(
        (el) => el.position.slice(depth - 1, depth) == relativePosition
      );
    });

    return groups.length ? groups : layer;
  });
  return layersSeparated;
};
